export default function identity(x) {
    return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/lib/utils/identity.js
// module id = 16
// module chunks = 2